export const paidBy = {
  sender: 'sender',
  recipient: 'recipient'
};
